import { z } from 'zod';

// Service Request DTO
export const GetLikedProductsServiceRequestDtoSchema = z.object({
  page: z.number().min(1),
  size: z.number().min(1).max(100),
});

export type GetLikedProductsServiceRequest = z.infer<
  typeof GetLikedProductsServiceRequestDtoSchema
>;

// Service Response DTO - API Layer와 분리된 독립적인 DTO
export const LikedProductServiceDtoSchema = z.object({
  goodsNo: z.string(),
  goodsName: z.string(),
  brandNo: z.number().nullish(),
  brandName: z.string(),
  imageUrl: z.string(),
  webUrl: z.string(),
  originalPrice: z.number(),
  price: z.number(),
  salesRate: z.number().nullish(),
  extraDiscountAmount: z.number().int().nullish(),
  finalPrice: z.number().int().nullish(),
  finalDiscount: z.number().int().nullish(),
  isLowestPrice: z.boolean().nullish(),
  isExclusive: z.boolean(),
  heartCount: z.number(),
  reviewCount: z.number(),
  reviewScore: z.string(),
  isLiked: z.boolean(),
  existsCoupon: z.boolean().nullish(),
  expectedEarnings: z.number(),
  largeCategoryNo: z.number().optional().nullable(),
  largeCategoryName: z.string().optional().nullable(),
  middleCategoryNo: z.number().optional().nullable(),
  middleCategoryName: z.string().optional().nullable(),
  smallCategoryNo: z.number().optional().nullable(),
  smallCategoryName: z.string().optional().nullable(),
});

export const GetLikedProductsServiceResponseDtoSchema = z.object({
  total: z.number().nullish(),
  list: z.array(LikedProductServiceDtoSchema),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type LikedProductService = z.infer<typeof LikedProductServiceDtoSchema>;
export type GetLikedProductsServiceResponse = z.infer<
  typeof GetLikedProductsServiceResponseDtoSchema
>;
